// A single (doctor × month) cell's mini month-strip: a horizontal time axis
// with faint week-ish dividers and one type-colored bar per entry that lands
// in this month. Mirrors `day-column.jsx` from the slots heatmap, but
// horizontal — slots are vertical day-plans, time off is horizontal date-spans.

import { cn } from "@/lib/utils";
import { entryAccent, monthCellGeometry } from "./time-off-utils";

// One absolutely-positioned bar per entry that intersects this month. Bars are
// stacked top-to-bottom at 7px intervals; ~10 fit before the bottom clips, at
// which point a "+N more" pill is rendered as a follow-up (v2). For v1 the
// stack silently truncates — typical doctors have 1-3 entries per month.
export function MonthCell({ rows = [], monthStart }) {
  return (
    <div className="relative h-full w-full overflow-hidden rounded-[3px] bg-black/5 dark:bg-muted/70">
      {/* Three faint vertical dividers at 25/50/75% (week-ish). Provides a
          visual hint of "early / mid / late month" without trying to align to
          actual weeks (which would require knowing the month's start weekday). */}
      <span
        aria-hidden
        className="absolute inset-y-0 left-1/4 w-px bg-muted-foreground/15"
      />
      <span
        aria-hidden
        className="absolute inset-y-0 left-1/2 w-px bg-muted-foreground/15"
      />
      <span
        aria-hidden
        className="absolute inset-y-0 left-3/4 w-px bg-muted-foreground/15"
      />

      {rows.map((row, idx) => {
        const geo = monthCellGeometry(row, monthStart);
        if (!geo) return null;
        const accent = entryAccent(row);
        const topPx = 4 + idx * 7;
        return (
          <span
            key={row.id ?? idx}
            title={row.title}
            className={cn(
              "absolute h-1.5 rounded-[1.5px]",
              accent.barClass,
              // Hairline so overlapping/same-color neighbours stay distinct.
              "shadow-[inset_0_0_0_1px_oklch(0.20_0.025_264_/_0.5)]",
            )}
            style={{
              top: `${topPx}px`,
              left: `${geo.leftPct}%`,
              width: `${geo.widthPct}%`,
              minWidth: 2,
            }}
          />
        );
      })}
    </div>
  );
}
